import { isAxiosError } from 'axios';

export interface SettledFileOperations<T> {
  failures: { reason: unknown }[];
  values: T[];
}

/** Wait for every independent file operation and retain every failure. */
export const settleFileOperations = async <T>(
  operations: Promise<T>[]
): Promise<SettledFileOperations<T>> => {
  const results = await Promise.allSettled(operations);
  const failures: { reason: unknown }[] = [];
  const values: T[] = [];

  results.forEach((result) => {
    if (result.status === 'fulfilled') {
      values.push(result.value);

      return;
    }

    const failure = { reason: result.reason };
    failures.push(failure);
  });

  return { failures, values };
};

/** Prefer an actionable failure over a masked transport failure. */
export const pickActionableFileFailure = (
  failures: { reason: unknown }[]
): unknown =>
  failures.find((failure) => !isAxiosError(failure.reason))?.reason ??
  failures[0]?.reason;
